// Polished vector logo for Rainey's Soul Food — chef hat + script wordmark.
export const Logo = ({ variant = "dark", className = "", showTagline = true }) => {
  const nameColor = "#0E9CA3"; // teal
  const taglineColor = "#12868C"; // deep teal
  const hatColor = variant === "light" ? "#FDFBF7" : "#0E9CA3";
  const scriptColor = variant === "light" ? "#FDFBF7" : nameColor;

  return (
    <div className={`flex items-center gap-3 ${className}`} aria-label="Rainey's Soul Food logo">
      <svg
        width="44"
        height="44"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0"
      >
        <g fill={hatColor}>
          <ellipse cx="32" cy="24" rx="15" ry="12" />
          <circle cx="17" cy="28" r="10" />
          <circle cx="47" cy="28" r="10" />
          <path d="M18 30 h28 v12 a4 4 0 0 1 -4 4 H22 a4 4 0 0 1 -4 -4 Z" />
        </g>
        <g stroke={variant === "light" ? "#0E9CA3" : "#FDFBF7"} strokeWidth="1.6" strokeLinecap="round" opacity="0.6">
          <line x1="26" y1="33" x2="26" y2="44" />
          <line x1="32" y1="33" x2="32" y2="44" />
          <line x1="38" y1="33" x2="38" y2="44" />
        </g>
      </svg>
      <div className="flex flex-col leading-none">
        <span
          className="font-script text-3xl md:text-[2rem] -mb-1"
          style={{ color: scriptColor }}
        >
          Rainey's
        </span>
        {showTagline && (
          <span
            className="font-body text-[0.6rem] md:text-[0.65rem] font-semibold uppercase tracking-[0.28em]"
            style={{ color: taglineColor }}
          >
            Authentic Soul Food
          </span>
        )}
      </div>
    </div>
  );
};

